import { Injectable } from '@angular/core';
@Injectable()
export class CubeMeasure {
    public id: number;
    public refId: number;
    public name: string;
    public cubeId: number;
    public measureId: number;
    public deleted: Boolean;
    public measureData: MeasureData;
    public formula: string;
    public aggregator: string;
    public recordIndex: number;
    public recordFormatFieldId: number;
    public formulaField: RecordFormatFieldData;
    public recordFormatField: RecordFormatFieldData;
    public measureNodeType: any;

}

export class CubeDimension {
    public id: number;
    public refId: number;
    public name: string;
    public cubeId: number;
    public dimensionId: number;
    public deleted: Boolean;
    public dimensionData = new DimensionData();
    public recordIndex: number;
    public recordFormatFieldId: number;
    public recordFormatField = new RecordFormatFieldData();
    public dimHierarchyLevelId: number;
    public dimHierarchyLevelData = new DimHierarchyLevelData();
}

export class DimensionData {
    public id: number;
    public refId: number;
    public dimCode: string;
    public name: string;
    public deleted: boolean;
    public description: string;
    public displayName: string;
    public dimExpression: string;
    public isTemplate: boolean;
    e;
    public category: string;
    public versionNo: string;
    public lastModifiedTime: Date;
    public status: string;
    public dimTime: boolean;
    public expectedCardinality: number;
    public dimHierarchyData = [];
}

export class MeasureData {
    public id: number;
    public refId: number;
    public name: string;
    public uomId: number;
    public measureCode: string;
    public measureDisplayName: string;
    public description: string;
    public filterExpression: string;
    public sqlFilterExpression: string;
    public formulaExpression: string;
    public dynamicFormulaExpression: string;
    public template: boolean;
    public formatstring: string;
    public kpi: boolean;
    public targetType: string;
    public achievementRangeMin: number;
    public achievementRangeMax: number;
    public lastModifiedTime: Date;
    public staticValue: string;
    public deleted: boolean;
    public tenantName: string;
    public rollup: string;
    public aggregator: string;
    public directType: string;
    public field = new RecordFormatFieldData();
    public enableCache: boolean;
    public dataVersionType: string;
    public dataVersion: Date;
    public closingPeriod: boolean;
    public measureStatusIndicator: any = [];
    public measureTarget: any = [];
}

export class DimHierarchyData {
    public id: number;
    public refId: number;
    public name: string;
    public dimensionData: DimensionData;
    public dimId: number;
    public deleted: Boolean;
    public allMemberName: string;
    public hasAll: Boolean;
    public recordFormatId: number;
    public recordFormat: RecordFormatData;
    public recordFormatFieldId: number;
    public recordFormatField: RecordFormatFieldData;
    public dimHierarchyLevelData = [];
}

export class DimHierarchyLevelData {
    public id: number;
    public refId: number;
    public levelnumber: number;
    public isUniqueMembers: Boolean;
    public name: string;
    public displayName: string;
    public levelType: string;
    public cardinality: number;
    public dimHierarchyId: number;
    public recordFormatFieldId: number;
    public nameFieldId: number;
    public ordinalFieldId: number;
    public dimHierarchy: DimHierarchyData;
    public parentId: number;
    public field: RecordFormatFieldData;
    public nameField: RecordFormatFieldData;
    public ordinalField: RecordFormatFieldData;
    public deleted: Boolean;
    public timeDimension: Boolean;
}

export class RecordFormatData {
    public id: number;
    public refId: number;
    public recordFormatCode: string;
    public recordFormatType: string;
    public name: string;
    public description: string;
    public input: Boolean;
    public output: Boolean;
    public catalog: Boolean;
    public fact: Boolean;
    public dimension: Boolean;
    public downloadable: Boolean;
    public uploadAllowed: Boolean;
    public displayName: string;
    public versionNo: string;
    public lastModifiedTime: Date;
    public status: string;
    public expectedCount: number;
    public expectedDailyCount: number;
    public updateFrequency: number;
    public deleted: Boolean;
    public recordFormatFieldData = [];
    public factNames: Set<string>;
    public extID: string;
    public dataSourceId: number;
}

export class RecordFormatFieldData {
    public id: number;
    public refId: number;
    public fieldDatatype: string;
    public fieldSize: number;
    public fieldName: string;
    public displayName: string;
    public isPK: Boolean;
    public expression: string;
    public keyType: string;
    public isNullable: string;
    public isUnique: Boolean;
    public validationExpression: string;
    public defaultValue: string;
    public recordFormatId: number;
    public refRecordFormatId: number;
    public isExternalId: Boolean;
    public formulaExpression: string;
    public formulaDesignerState: string;
    public recordIndex: number;
    public recordFormat: RecordFormatData;
    public refRecordFormatName: string;
    public deleted: Boolean;
    public isDim: Boolean;
    public sysCreated: Boolean;
}

export class DataSourceStorageType {
    public FILE_S3 = {
        connection: '',
        customParameter : [ 'Access Key', 'Secret Key', 'Location', 'End Point Url', 'Region'],
        engineType: 'DRILL'
    };
    public FILE_SFTP = {
        connection: '',
        customParameter: ['Location', 'Host', 'Port'],
        engineType: 'DRILL'

    };

    public FILE_DFS = {
        connection: '',
        customParameter: ['Location'],
        engineType: 'DRILL'

    };

    public MONGO = {
        connection: '',
        engineType: 'DRILL'
    };

    // public DRILL_HIVE = {
    //     type: 'HIVE',
    //     connection: '',
    //     customParameter : ['Default file location', 'sasl Enabled'],
    //     engineType: 'DRILL'
    // };

    // public DRILL_HBASE = {
    //     type: 'HBASE',
    //     connection: 'Zookeeper Quorum',
    //     customParameter : ['Default file location', 'sasl Enabled'],
    //     engineType: 'DRILL'
    // };

    // public PRESTO_HIVE = { 
    //     type: 'HIVE',        
    //     engineType: 'PRESTO'
    // };

    public HIVE = { engineType: 'PRESTO' };

    public MYSQL = { engineType: 'PRESTO' };

    public REDIS = { engineType: 'PRESTO' };

    public REDSHIFT = { engineType: 'PRESTO' };

    public KAFKA = { engineType: 'PRESTO' };

    public MONGODB = { engineType: 'PRESTO' };

    public POSTGRESQL = { engineType: 'PRESTO' };

    public CASSANDRA = { engineType: 'PRESTO' };

    public SQLSERVER = { engineType: ['PRESTO', 'SSAS'] };

    public HBASE = { engineType: 'KYLIN' };

    public CLICK_HOUSE = { engineType: 'CLICK_HOUSE' }

}


// WEBPACK FOOTER //
// ./src/app/bi/admin/pocdesigner/service.ts